module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_vm._v("\n\t\t\tRatioCalc\n\t\t\t"), _c('button', {
    class: {
      '-active': _vm.showHelp
    },
    on: {
      "click": _vm.toggleHelp
    }
  }, [_c('c-icon', {
    attrs: {
      "name": 'question-circle'
    }
  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "e-grid -double"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', [_c('label', {
    staticClass: "e-label"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("数字を入力してください : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    staticClass: "e-input-text -center -remark",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "change": _vm.calculate,
      "keyup": _vm.calculate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "e-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-ratiocalc-result"
  }, [_c('div', {
    staticClass: "c-ratiocalc-result__item",
    class: {
      '-active': _vm.type === 'golden'
    }
  }, [_c('div', {
    staticClass: "c-ratiocalc-result__label"
  }, [_c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "golden"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "golden")
    },
    on: {
      "__c": function($event) {
        _vm.type = "golden"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('ul', {
    staticClass: "c-ratiocalc-result__field"
  }, [_c('li', {
    staticClass: "c-ratiocalc-result__field-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    staticClass: "e-input-text -center -small -remark",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-ratiocalc-result__gutter"
  }, [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.result.golden.large),
      expression: "result.golden.large"
    }],
    staticClass: "e-input-text -center -small",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.result.golden.large)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.result.golden.large = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "c-ratiocalc-result__field-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.result.golden.small),
      expression: "result.golden.small"
    }],
    staticClass: "e-input-text -center -small",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.result.golden.small)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.result.golden.small = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-ratiocalc-result__gutter"
  }, [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    staticClass: "e-input-text -center -small -remark",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-ratiocalc-result__item",
    class: {
      '-active': _vm.type === 'silver'
    }
  }, [_c('div', {
    staticClass: "c-ratiocalc-result__label"
  }, [_c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "silver"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "silver")
    },
    on: {
      "__c": function($event) {
        _vm.type = "silver"
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('ul', {
    staticClass: "c-ratiocalc-result__field"
  }, [_c('li', {
    staticClass: "c-ratiocalc-result__field-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    staticClass: "e-input-text -center -small -remark",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-ratiocalc-result__gutter"
  }, [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.result.silver.large),
      expression: "result.silver.large"
    }],
    staticClass: "e-input-text -center -small",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.result.silver.large)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.result.silver.large = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "c-ratiocalc-result__field-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.result.silver.small),
      expression: "result.silver.small"
    }],
    staticClass: "e-input-text -center -small",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.result.silver.small)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.result.silver.small = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-ratiocalc-result__gutter"
  }, [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    staticClass: "e-input-text -center -small -remark",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "c-ratiocalc-preview",
    class: {
      '-silver': _vm.type === 'silver'
    }
  }, [_c('div', {
    staticClass: "c-ratiocalc-preview__large"
  }, [_c('span', {
    staticClass: "c-ratiocalc-preview__tip -top"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.type === "golden" ? _vm.result.golden.large : _vm.result.silver.large) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "c-ratiocalc-preview__tip -right"
  }, [_vm._v(_vm._s(_vm.input))]), _vm._v(" "), _c('div', {
    staticClass: "c-ratiocalc-preview__small"
  }, [_c('span', {
    staticClass: "c-ratiocalc-preview__tip -top"
  }, [_vm._v(_vm._s(_vm.input))]), _vm._v(" "), _c('span', {
    staticClass: "c-ratiocalc-preview__tip -right"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.type === "golden" ? _vm.result.golden.small : _vm.result.silver.small) + "\n\t\t\t\t\t\t\t\t")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-help"
  }, [_c('div', {
    staticClass: "c-help__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t黄金比・白銀比計算機。\n\t\t\t\t\t結果は小数点第4位で丸められます。\n\t\t\t\t")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_vm._v("黄金比 "), _c('small', [_vm._v("Golden Ratio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_vm._v("白銀比 "), _c('small', [_vm._v("Silver Ratio")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f6fe38c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/ratiocalc.vue
// module id = 59
// module chunks = 0